<template>
  <v-dialog v-model="show" max-width="900px" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        Impresión de etiquetas
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-select
                dense
                outlined
                label="Selecciona tipo de etiqueta"
                :items="labelsKinds"
                v-model="labelType"
                return-object
              ></v-select>
            </v-col>
          </v-row>
          <v-form
            ref="form_product"
            lazy-validation
            v-if="labelType && labelType.value == 'LABEL_PRODUCT'"
          >
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="selectedProduct"
                  :items="filteredProducts"
                  item-text="nombre"
                  item-value="codigo"
                  label="Seleccione el producto"
                  dense
                  outlined
                  clearable
                  return-object
                  @change="updateProductFields"
                  :rules="validation('producto')"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                      <v-list-item-subtitle
                        >Código: {{ item.codigoLetras }} |
                        {{ item.tipo.toUpperCase() }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="formProduct.presentation"
                  :items="filteredPresentations"
                  item-text="text"
                  item-value="value"
                  dense
                  outlined
                  label="Presentación"
                  :rules="validation('presentación')"
                  @change="updateConcentration"
                  return-object
                ></v-select>
              </v-col>

              <v-col md="6">
                <v-text-field
                  v-model="formProduct.labelName"
                  dense
                  outlined
                  label="Nombre en etiqueta"
                  :rules="validation('nombre')"
                ></v-text-field>
              </v-col>

              <v-col md="6">
                <v-text-field
                  v-model="formProduct.concentration"
                  dense
                  outlined
                  label="Concentración"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col md="6">
                <v-text-field
                  v-model="formProduct.lote"
                  dense
                  outlined
                  label="Lote (ej: 0603 para lote 6, mes 3)"
                  :rules="[
                    (v) => !!v || 'Campo obligatorio',
                    (v) => /^\d{4}$/.test(v) || 'Debe ser 4 dígitos (ej: 0603)',
                  ]"
                  @input="generateFullLotCode"
                ></v-text-field>
              </v-col>

              <v-col md="6">
                <v-text-field
                  v-model="formProduct.fullLotCode"
                  dense
                  outlined
                  label="Código de lote completo"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col md="6">
                <v-text-field
                  v-model="formProduct.packagingDate"
                  dense
                  outlined
                  label="Fecha de envasado"
                  type="date"
                  locale="es"
                  :rules="validation('fecha')"
                ></v-text-field>
              </v-col>

              <v-col md="6">
                <v-text-field
                  v-model="formProduct.content"
                  dense
                  outlined
                  label="Contenido neto"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col md="6">
                <v-text-field
                  v-model="formProduct.pagesQuantity"
                  dense
                  outlined
                  label="Cantidad de etiquetas"
                  :rules="[
                    (v) => !!v || 'Campo obligatorio',
                    (v) => v > 0 || 'Cantidad tiene que ser mayor a cero',
                  ]"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-form
            ref="form_box"
            lazy-validation
            v-if="labelType && labelType.value == 'LABEL_BOX'"
          >
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="formBox.productType"
                  :items="boxProductTypes"
                  dense
                  outlined
                  label="Tipo de producto"
                  :rules="validation('tipo de producto')"
                  @change="handleProductTypeChange"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6" v-if="formBox.productType !== 'KIT'">
                <v-text-field
                  v-model.number="totalBoxes"
                  dense
                  outlined
                  label="Número total de cajas"
                  type="number"
                  min="1"
                  :rules="[
                    (v) => !!v || 'Campo obligatorio',
                    (v) => v > 0 || 'Debe ser mayor a cero',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="remainingBoxesText"
                  dense
                  outlined
                  label="Cajas restantes por imprimir"
                  readonly
                  :color="remainingBoxes <= 0 ? 'success' : 'primary'"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="formBox.productType == 'KIT'">
                <v-select
                  v-model="formBox.kitType"
                  :items="kitPresentations"
                  dense
                  outlined
                  label="Tipo de kit"
                  return-object
                  :rules="validation('tipo de kit')"
                ></v-select>
              </v-col>
              <v-col md="6">
                <v-text-field
                  v-model="formBox.orderNumber"
                  dense
                  outlined
                  label="Número de OP"
                  :rules="validation('op')"
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  v-model="formBox.clientName"
                  dense
                  outlined
                  label="Nombre cliente"
                  :rules="validation('cliente')"
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  v-model="formBox.nameLabelBox"
                  dense
                  outlined
                  label="Nombre de la etiqueta de caja (opcional)"
                ></v-text-field>
              </v-col>
              <v-col md="6" v-if="formBox.productType !== 'KIT'">
                <v-combobox
                  v-model="formBox.microorganismName"
                  :search-input.sync="search"
                  :items="identificationsFounded"
                  dense
                  outlined
                  clearable
                  item-text="identificationName"
                  :loading="loader"
                  label="Nombre de producto"
                  hide-no-data
                  :rules="validation('microorganismo')"
                  return-object
                ></v-combobox>
              </v-col>
              <v-col md="6">
                <v-text-field
                  v-model="formBox.productQuantity"
                  dense
                  outlined
                  label="Cantidad de productos en caja"
                  :rules="[
                    (v) => !!v || 'Campo obligatorio',
                    (v) => v > 0 || 'Cantidad tiene que ser mayor a cero',
                  ]"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col md="6" v-if="formBox.productType !== 'KIT'">
                <v-select
                  v-model="formBox.presentation"
                  :items="productPresentation"
                  item-text="text"
                  dense
                  outlined
                  label="Presentación"
                  :rules="validation('presentación')"
                  return-object
                ></v-select>
              </v-col>
              <v-col md="6" v-if="formBox.productType !== 'KIT'">
                <v-select
                  v-model="formBox.boxPresentation"
                  :items="boxPresentation"
                  item-text="text"
                  dense
                  outlined
                  label="Tipo de caja"
                  :rules="validation('tipo de caja')"
                  return-object
                ></v-select>
              </v-col>
            </v-row>

            <v-row
              v-if="printHistory.length > 0 && formBox.productType !== 'KIT'"
            >
              <v-col cols="12">
                <v-subheader class="pl-0 text-h6">
                  Historial de Impresión
                </v-subheader>
                <v-slide-group show-arrows class="py-4">
                  <v-slide-item
                    v-for="(item, index) in printHistory"
                    :key="index"
                  >
                    <v-card
                      class="ma-2"
                      width="220"
                      elevation="3"
                      :color="
                        item.completed ? 'green lighten-4' : 'blue lighten-4'
                      "
                    >
                      <v-card-text class="text-center">
                        <div class="text-h6">
                          {{ item.labelCount }} etiquetas
                        </div>
                        <div class="text-subtitle-1">
                          Cajas {{ item.start }} - {{ item.end }}
                        </div>
                        <div class="text-caption">
                          Generado: {{ formatTime(item.timestamp) }}
                        </div>
                        <v-progress-linear
                          :value="(item.labelCount / totalBoxes) * 100"
                          height="10"
                          :color="item.completed ? 'success' : 'primary'"
                          class="mt-2"
                        ></v-progress-linear>
                        <div class="text-caption mt-1">
                          {{
                            Math.round((item.labelCount / totalBoxes) * 100)
                          }}% del total
                        </div>
                      </v-card-text>
                      <v-card-actions class="justify-center">
                        <v-btn
                          small
                          color="error"
                          @click.stop="removeHistoryItem(index)"
                          :disabled="isLoading"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          color="info"
                          @click.stop="reprintItem(item)"
                          :disabled="isLoading"
                        >
                          <v-icon small>mdi-printer</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="gray"
                block
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cerrar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="printLabels"
                :loading="isLoading"
                :disabled="
                  labelType &&
                  labelType.value === 'LABEL_BOX' &&
                  formBox.productType !== 'KIT' &&
                  remainingBoxes <= 0
                "
              >
                {{
                  labelType && labelType.value === "LABEL_BOX"
                    ? "Generar e Imprimir"
                    : "Imprimir"
                }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * LabelPrintDialog Component
 *
 * A dialog component for generating and printing product and box labels.
 * Handles two types of labels:
 * 1. Product labels with detailed product information
 * 2. Box labels with shipping/packaging information
 *
 * Features:
 * - Form validation
 * - PDF generation
 * - Print history tracking
 * - Microorganism search
 */

// VUEX STORE
import { mapActions, mapMutations } from "vuex";
// Validations
import { requiredValidation } from "@/helpers/validations.js";
// PDF libraries
import { PDFDocument, degrees } from "pdf-lib";
// HTTP client
import axios from "axios";

/**
 * Product data constants
 * @constant {Array} PRODUCTOS - Complete list of available biological products
 * @constant {Array} PRESENTACIONES - Available product presentations
 */
const PRODUCTOS = [
  // BACTERIA
  {
    tipo: "bacteria",
    nombre: "Azospirillum sp",
    codigo: "21",
    codigoLetras: "AZSP",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Azospirillum",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus licheniformis",
    codigo: "17",
    codigoLetras: "BLXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico B. licheniformis",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus licheniformis",
    codigo: "46",
    codigoLetras: "BLNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico B. liqueniformis",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus pumillus",
    codigo: "22",
    codigoLetras: "BPXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico B. pumillus",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus pumillus",
    codigo: "55",
    codigoLetras: "BPNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico B. pumillus",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus thuringiensis kurstaki",
    codigo: "04",
    codigoLetras: "BTKX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico B. thuringiensis",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus thuringiensis aizawai",
    codigo: "40",
    codigoLetras: "BTAX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico B. thuringiensis",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus sp",
    codigo: "35",
    codigoLetras: "BSPX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Bacillus sp.",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus subtilis",
    codigo: "02",
    codigoLetras: "BSXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Para Suelos",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Pseudomonas fluorescens",
    codigo: "03",
    codigoLetras: "PFXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Para Suelos",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Rhizobium sp",
    codigo: "13",
    codigoLetras: "RSPX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Para Suelos",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Azotobacter sp",
    codigo: "15",
    codigoLetras: "AZXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Para Suelos",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus amyloliquefaciens",
    codigo: "16",
    codigoLetras: "BAXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Para Suelos",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus megaterium",
    codigo: "18",
    codigoLetras: "BMXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Para Suelos",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus megaterium",
    codigo: "42",
    codigoLetras: "BMNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Para Suelos",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus subtilis",
    codigo: "43",
    codigoLetras: "BSNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Para Suelos",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus amyloliquefaciens",
    codigo: "44",
    codigoLetras: "BANT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Para Suelos",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Azotobacter sp",
    codigo: "45",
    codigoLetras: "AZNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Para Suelos",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Pseudomonas fluorescens",
    codigo: "47",
    codigoLetras: "PFNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Para Suelos",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Streptomyces sp",
    codigo: "23",
    codigoLetras: "SSPX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Streptomyces",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Bacillus paralicheniformis",
    codigo: "54",
    codigoLetras: "BPLX",
    cepas: "SOLENA",
    nombreEtiqueta: "CB Bacillus paralicheniformis",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Chitinophaga eiseniae",
    codigo: "62",
    codigoLetras: "CEXX",
    cepas: "SOLENA",
    nombreEtiqueta: "CB Chitinophaga eiseniae",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Pseudomonas asiatica",
    codigo: "58",
    codigoLetras: "PAXX",
    cepas: "SOLENA",
    nombreEtiqueta: "CB Pseudomonas asiatica",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "Pseudomonas sp",
    codigo: "56",
    codigoLetras: "PSPX",
    cepas: "SOLENA",
    nombreEtiqueta: "CB Pseudomonas sp.",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "P12 posible risobium",
    codigo: "52",
    codigoLetras: "RSR3",
    cepas: "NATIVA",
    nombreEtiqueta: "",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },
  {
    tipo: "bacteria",
    nombre: "PR3 risobium pusense",
    codigo: "53",
    codigoLetras: "RS12",
    cepas: "NATIVA",
    nombreEtiqueta: "",
    concentraciones: { "5L": "1x10^11 UFC/L" },
  },

  // ACTINO
  {
    tipo: "actino",
    nombre: "Streptomyces griseoviridis",
    codigo: "12",
    codigoLetras: "SGXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Streptomyces",
    concentraciones: { "250g": "1x10^11 UFC/dosis", "1 kg": "4x10^11 UFC/kg" },
  },
  {
    tipo: "actino",
    nombre: "Streptomyces griseoviridis 2993",
    codigo: "63",
    codigoLetras: "SGXX",
    cepas: "2993",
    nombreEtiqueta: "Capital Biológico Streptomyces",
    concentraciones: { "250g": "1x10^11 UFC/dosis", "1 kg": "4x10^11 UFC/kg" },
  },

  // FUNGI
  {
    tipo: "hongo",
    nombre: "Beauveria bassiana",
    codigo: "07",
    codigoLetras: "BBXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Beauveria",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Gliocladium catenulatum",
    codigo: "32",
    codigoLetras: "GCXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Gliocladium c.",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Gliocladium virens",
    codigo: "14",
    codigoLetras: "GVXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Gliocladium v.",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Isaria fumosorosea",
    codigo: "09",
    codigoLetras: "IFXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Isaria",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Lecanicillium lecanii",
    codigo: "05",
    codigoLetras: "LLXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Lecanicillium",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Metarhizium anisopliae",
    codigo: "08",
    codigoLetras: "MAXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Metarhizium",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Paecilomyces lilacinus",
    codigo: "10",
    codigoLetras: "PLXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Nemátodos",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Pochonia chlamydosporia",
    codigo: "11",
    codigoLetras: "PCXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Nemátodos",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma harzianum",
    codigo: "06",
    codigoLetras: "THXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma asperellum",
    codigo: "19",
    codigoLetras: "TAXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma crassum",
    codigo: "24",
    codigoLetras: "TCNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma gamsii",
    codigo: "25",
    codigoLetras: "TGNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma koningii",
    codigo: "26",
    codigoLetras: "TKNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma koningiopsis",
    codigo: "27",
    codigoLetras: "TKGN",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma ovalisporum",
    codigo: "28",
    codigoLetras: "TOXX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma sp",
    codigo: "29",
    codigoLetras: "TSPX",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma virens",
    codigo: "30",
    codigoLetras: "TVNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma viride",
    codigo: "31",
    codigoLetras: "TVDN",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma longibrachiatum",
    codigo: "33",
    codigoLetras: "TLNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma reesei",
    codigo: "34",
    codigoLetras: "TRNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma aggressivum",
    codigo: "36",
    codigoLetras: "TAGN",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma orientale",
    codigo: "37",
    codigoLetras: "TORN",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma harzianum",
    codigo: "38",
    codigoLetras: "THNT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma asperellum",
    codigo: "39",
    codigoLetras: "TANT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma ovalisporum",
    codigo: "41",
    codigoLetras: "TONT",
    cepas: "NATIVA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Consorcio TRC",
    codigo: "57",
    codigoLetras: "CTRC",
    cepas: "SOLENA",
    nombreEtiqueta: "Capital Biológico Trichoderma",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma lixii 1",
    codigo: "49",
    codigoLetras: "",
    cepas: "SOLENA",
    nombreEtiqueta: "",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma lixii 2",
    codigo: "50",
    codigoLetras: "",
    cepas: "SOLENA",
    nombreEtiqueta: "",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma ghanense",
    codigo: "51",
    codigoLetras: "",
    cepas: "SOLENA",
    nombreEtiqueta: "",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma asperellum 2713",
    codigo: "59",
    codigoLetras: "",
    cepas: "SOLENA",
    nombreEtiqueta: "",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma asperellum 2714",
    codigo: "60",
    codigoLetras: "",
    cepas: "SOLENA",
    nombreEtiqueta: "",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
  {
    tipo: "hongo",
    nombre: "Trichoderma harzianum 2702",
    codigo: "61",
    codigoLetras: "",
    cepas: "SOLENA",
    nombreEtiqueta: "",
    concentraciones: {
      "500g": "1x10^11 conidios/dosis",
      "2kg": "2x10^11 conidios/kg",
    },
  },
];

const PRESENTACIONES = [
  { text: "5L", value: "5L", code: "005", tipo: "bacteria" },
  { text: "250 grs", value: "250g", code: "250", tipo: "actino" },
  { text: "500 grs", value: "500g", code: "500", tipo: "hongo" },
  { text: "1 kg", value: "1 kg", code: "001", tipo: "actino" },
  { text: "2 kg", value: "2kg", code: "002", tipo: "hongo" },
];

const KIT = [
  { text: "Kit Híbrido", value: "KIT_HIBRID" },
  { text: "CMDA 1 Kit qPCR", value: "KIT_1" },
  { text: "CMDA 1.1 Kit qPCR", value: "KIT_1_1" },
  { text: "CMDA 2 Kit qPCR", value: "KIT_2" },
  { text: "CMDA 3 Kit qPCR", value: "KIT_3" },
  { text: "CMDA 4 Kit qPCR", value: "KIT_4" },
  { text: "CMDA 5 Kit qPCR", value: "KIT_5" },
  { text: "CMDA 6 Kit qPCR", value: "KIT_6" },
  { text: "CMDA 7 Kit qPCR", value: "KIT_7" },
  { text: "CMDA 8 Kit qPCR", value: "KIT_8" },
  { text: "CMDA 9 Kit qPCR", value: "KIT_9" },
  { text: "CMDA 10 Kit qPCR", value: "KIT_10" },
  { text: "CMDA 11 Kit qPCR", value: "KIT_11" },
  { text: "CMDA 12 Kit qPCR", value: "KIT_12" },
  { text: "CMDA 13 Kit qPCR", value: "KIT_13" },
  { text: "Kit Metagenoma V1", value: "KIT_META_1" },
  { text: "Kit Metagenoma V2", value: "KIT_META_2" },
  { text: "Kit Set-up de Productos V3", value: "KIT_SETUP_3" },
  { text: "Kit Set-up de Productos V4", value: "KIT_SETUP_4" },
  { text: "Kit MISS test V1", value: "KIT_TEST_1" },
  { text: "Kit MISS test V2", value: "KIT_TEST_2" },
  { text: "Kit Muestras P1", value: "KIT_P1" },
  { text: "Kit Muestras P2", value: "KIT_P2" },
];

export default {
  name: "LabelPrintDialog",

  /**
   * Component props
   * @property {Boolean} value - Controls dialog visibility (v-model)
   */
  props: {
    value: Boolean,
  },
  data: () => ({
    isLoading: false,
    labelsKinds: [
      { text: "Etiqueta producto", value: "LABEL_PRODUCT" },
      { text: "Etiqueta caja", value: "LABEL_BOX" },
    ],
    boxProductTypes: [
      { text: "Microorganismos / Ag Boost", value: "MICROORGANISM" },
      { text: "Kit", value: "KIT" },
    ],
    labelType: null,
    search: null,
    loader: false,
    identificationsFounded: [],
    selectedProduct: null,
    products: PRODUCTOS,
    productPresentations: PRESENTACIONES,
    kitPresentations: KIT,
    formProduct: {
      productType: null,
      labelName: null,
      concentration: null,
      lote: null,
      fullLotCode: null,
      packagingDate: null,
      content: null,
      reverseText: "Instrucciones al reverso",
      pagesQuantity: null,
      presentation: null,
    },
    totalBoxes: null,
    printHistory: [],
    formBox: {
      kitType: null,
      orderNumber: null,
      clientName: null,
      nameLabelBox: null,
      microorganismName: null,
      productQuantity: null,
      presentation: null,
      boxPresentation: null,
    },
    productPresentation: [
      { text: "5L", value: "DRUM" },
      { text: "250 grs", value: "250" },
      { text: "500 grs", value: "500" },
      { text: "1 kg", value: "10000" },
      { text: "2 kg", value: "20000" },
    ],
    boxPresentation: [
      { text: "Caja café", value: "BOX_BROWN" },
      { text: "Caja kit", value: "BOX_KIT" },
    ],
  }),

  computed: {
    /**
     * Controls dialog visibility with two-way binding
     * @returns {Boolean}
     */
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    /**
     * Filters products based on selected presentation type
     * @returns {Array}
     */
    filteredProducts() {
      if (!this.formProduct.presentation) return this.products;
      const tipoPresentacion = this.productPresentations.find(
        (p) => p.value === this.formProduct.presentation?.value
      )?.tipo;
      return this.products.filter((p) => p.tipo === tipoPresentacion);
    },

    /**
     * Filters presentations based on selected product type
     * @returns {Array}
     */
    filteredPresentations() {
      if (!this.selectedProduct) return this.productPresentations;
      return this.productPresentations.filter(
        (p) => p.tipo === this.selectedProduct.tipo
      );
    },

    /**
     * Calculates remaining boxes to print
     * @returns {Number}
     */
    remainingBoxes() {
      if (!this.totalBoxes || this.formBox.productType === "KIT") return 0;
      const printed = this.printHistory.reduce(
        (sum, item) => sum + item.labelCount,
        0
      );
      return Math.max(0, this.totalBoxes - printed);
    },

    /**
     * Formatted text for remaining boxes display
     * @returns {String}
     */
    remainingBoxesText() {
      if (this.formBox.productType === "KIT") {
        return "N/A para KIT";
      }
      return `${this.remainingBoxes} de ${this.totalBoxes || 0}`;
    },

    /**
     * Calculates the starting box number for next print batch
     * @returns {Number}
     */
    currentBoxStart() {
      if (this.printHistory.length === 0 || this.formBox.productType === "KIT")
        return 1;
      return this.printHistory[this.printHistory.length - 1].end + 1;
    },
  },

  methods: {
    ...mapActions("bioactives", ["searchBioactives"]),
    ...mapMutations(["SET_CANCEL_TOKEN"]),

    /**
     * Formats timestamp to localized time string
     * @param {Number} timestamp - Unix timestamp
     * @returns {String} Formatted time string
     */
    formatTime(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    /**
     * Formats date string from YYYY-MM-DD to DD/MM/YYYY
     * @param {String} dateString - Date in YYYY-MM-DD format
     * @returns {String} Date in DD/MM/YYYY format
     */
    formatDate(dateString) {
      if (!dateString) return "";

      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },

    /**
     * Closes the modal and resets form state
     */
    closeModal() {
      this.show = false;
      this.printHistory = [];
      this.selectedProduct = null;
      this.formBox.productType = null;
      this.$refs.form_product?.reset();
      this.$refs.form_box?.reset();
    },

    /**
     * Handles changes in product type selection
     * Clears microorganism fields if type is KIT
     */
    handleProductTypeChange() {
      if (this.formBox.productType === "KIT") {
        this.formBox.microorganismName = null;
        this.printHistory = [];
      }
    },

    /**
     * Removes an item from print history
     * @param {Number} index - Index of item to remove
     */
    removeHistoryItem(index) {
      this.printHistory.splice(index, 1);
    },

    /**
     * Reprints a history item
     * @param {Object} item - History item to reprint
     */
    reprintItem(item) {
      this.generateBoxLabels(
        item.labelCount,
        item.start,
        item.end,
        item.distribution
      );
    },

    /**
     * Adds centered text to PDF document
     * @param {Object} pdf - PDF document instance
     * @param {String} text - Text to add
     * @param {Number} yPosition - Vertical position
     * @param {String} [half] - Optional half page position ('left' or 'right')
     */
    addCenteredText(pdf, text, yPosition, half) {
      const pageWidth = pdf.internal.pageSize.getWidth();
      const halfWidth = pageWidth / 2;
      const textWidth =
        (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize()) /
        pdf.internal.scaleFactor;
      let xPosition;
      if (half === "left") {
        xPosition = (halfWidth - textWidth) / 2;
      } else if (half === "right") {
        xPosition = halfWidth + (halfWidth - textWidth) / 2;
      } else {
        xPosition = (pageWidth - textWidth) / 2;
      }
      pdf.text(text, xPosition, yPosition);
    },

    /**
     * Handles print button click based on label type
     */
    async printLabels() {
      if (this.labelType.value == "LABEL_PRODUCT") {
        await this.processLabelProduct();
      } else if (this.labelType.value == "LABEL_BOX") {
        await this.processLabelBox();
      }
    },

    /**
     * Updates product fields when product selection changes
     * @param {Object} product - Selected product
     */
    updateProductFields(product) {
      if (product) {
        this.formProduct.labelName = product.nombreEtiqueta;
        this.formProduct.presentation = null;
        this.formProduct.concentration = null;
        this.formProduct.content = null;
        this.generateFullLotCode();
      }
    },

    /**
     * Updates concentration when presentation changes
     * @param {Object} presentation - Selected presentation
     */
    updateConcentration(presentation) {
      if (this.selectedProduct && presentation) {
        this.formProduct.concentration =
          this.selectedProduct.concentraciones[presentation.value] || "N/A";
        this.formProduct.content = presentation.value;
        this.generateFullLotCode();
      }
    },

    /**
     * Generates full lot code from product and presentation data
     */
    generateFullLotCode() {
      if (
        !this.selectedProduct ||
        !this.formProduct.lote ||
        !this.formProduct.presentation
      ) {
        this.formProduct.fullLotCode = null;
        return;
      }

      const presentation = this.productPresentations.find(
        (p) => p.value === this.formProduct.presentation.value
      );

      if (
        this.formProduct.lote.length === 4 &&
        presentation &&
        this.selectedProduct.codigoLetras
      ) {
        this.formProduct.fullLotCode = `${this.formProduct.lote}${this.selectedProduct.codigo}${presentation.code}-${this.selectedProduct.codigoLetras}/${this.selectedProduct.codigo}`;
      }
    },

    /**
     * Processes product label printing
     */
    async processLabelProduct() {
      if (this.$refs.form_product.validate()) {
        const cmPoints = 28.3465;
        const width = 8.5 * cmPoints;
        const height = 8.5 * cmPoints;
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "pt",
          format: [width, height],
        });

        for (let index = 0; index < this.formProduct.pagesQuantity; index++) {
          pdf.setFontSize(12);
          this.addCenteredText(pdf, this.formProduct.labelName, 3 * cmPoints);
          pdf.setFontSize(10);
          this.addCenteredText(
            pdf,
            this.formProduct.concentration,
            3.5 * cmPoints
          );
          this.addCenteredText(
            pdf,
            `Lote: ${this.formProduct.fullLotCode}`,
            4 * cmPoints
          );
          this.addCenteredText(
            pdf,
            `Envasado: ${this.formatDate(this.formProduct.packagingDate)}`,
            4.5 * cmPoints
          );
          this.addCenteredText(
            pdf,
            `Cont. Neto: ${this.formProduct.content}`,
            5 * cmPoints
          );
          this.addCenteredText(
            pdf,
            this.formProduct.reverseText,
            5.5 * cmPoints
          );

          if (index < this.formProduct.pagesQuantity - 1) {
            pdf.addPage();
          }
        }

        const pdfBytes = pdf.output("arraybuffer");
        const pdfDoc = await PDFDocument.load(pdfBytes);
        const pages = pdfDoc.getPages();
        pages.forEach((page) => {
          page.setRotation(degrees(270));
        });
        const rotatedPdfBytes = await pdfDoc.save();
        this.downloadPdf(rotatedPdfBytes);
      }
    },

    /**
     * Downloads generated PDF
     * @param {Uint8Array} pdfBytes - PDF bytes to download
     */
    downloadPdf(pdfBytes) {
      const now = new Date();
      const date = now
        .toLocaleString("es-ES", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(/,/g, "");
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download =
        this.labelType.value === "LABEL_PRODUCT"
          ? `etiquetas_producto_${date}.pdf`
          : `etiquetas_caja_${date}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    },

    /**
     * Processes box label printing
     */
    async processLabelBox() {
      if (this.$refs.form_box.validate()) {
        if (this.formBox.productType === "KIT") {
          await this.generateKitLabels();
          return;
        }

        if (this.totalBoxes) {
          let boxesToGenerate = 0;
          const remaining = this.remainingBoxes;

          if (this.formBox.boxPresentation.value == "BOX_BROWN") {
            const rules = [
              { key: "DRUM", size: 4 },
              { key: "250", size: 45 },
              { key: "500", size: 30 },
              { key: "10000", size: 16 },
              { key: "20000", size: 8 },
            ];
            const size = rules.find(
              (element) => element.key == this.formBox.presentation.value
            ).size;
            boxesToGenerate = Math.ceil(
              parseInt(this.formBox.productQuantity) / size
            );
          } else if (this.formBox.boxPresentation.value == "BOX_KIT") {
            const rules = [
              { key: "DRUM", size: 1 },
              { key: "250", size: 7 },
              { key: "500", size: 6 },
              { key: "10000", size: 1 },
              { key: "20000", size: 1 },
            ];
            const size = rules.find(
              (element) => element.key == this.formBox.presentation.value
            ).size;
            boxesToGenerate = Math.ceil(
              parseInt(this.formBox.productQuantity) / size
            );
          }

          boxesToGenerate = Math.min(boxesToGenerate, remaining);

          if (boxesToGenerate > 0) {
            const startBox = this.currentBoxStart;
            const endBox = startBox + boxesToGenerate - 1;
            const productQty = parseInt(this.formBox.productQuantity);

            const boxDistribution = this.distributeInBoxes(
              productQty,
              boxesToGenerate
            );

            const sum = boxDistribution.reduce((a, b) => a + b, 0);
            if (sum !== productQty) {
              boxDistribution[boxDistribution.length - 1] += productQty - sum;
            }

            this.printHistory.push({
              labelCount: boxesToGenerate,
              start: startBox,
              end: endBox,
              timestamp: new Date().getTime(),
              completed: remaining - boxesToGenerate <= 0,
              distribution: [...boxDistribution],
            });

            await this.generateBoxLabels(
              boxesToGenerate,
              startBox,
              endBox,
              boxDistribution
            );
          }
        }
      }
    },

    /**
     * Generates Kit box labels PDF
     */
    async generateKitLabels() {
      const cmToPoints = 28.3465;
      const labelSize = 10 * cmToPoints;
      const pdf = new jsPDF({
        unit: "pt",
        format: [labelSize, labelSize],
      });

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(15);
      pdf.setDrawColor(0, 0, 0);

      pdf.setLineWidth(1.5);
      pdf.rect(5, 5, labelSize - 10, labelSize - 10);

      pdf.setLineWidth(1.5);
      pdf.line(5, 3.3 * cmToPoints, labelSize - 5, 3.3 * cmToPoints);
      pdf.line(5, 6.6 * cmToPoints, labelSize - 5, 6.6 * cmToPoints);

      this.addCenteredText(pdf, "Cliente", 1 * cmToPoints);
      this.addCenteredText(pdf, this.formBox.orderNumber, 1.5 * cmToPoints);
      this.addCenteredText(pdf, this.formBox.clientName, 2 * cmToPoints);

      if (this.formBox.nameLabelBox && this.formBox.nameLabelBox.length > 0) {
        this.addCenteredText(pdf, this.formBox.nameLabelBox, 2.5 * cmToPoints);
      }

      pdf.text("Producto", 0.5 * cmToPoints, 3.8 * cmToPoints);
      this.addCenteredText(pdf, this.formBox.kitType.text, 4.95 * cmToPoints);

      this.addCenteredText(pdf, "Cantidad", 7.1 * cmToPoints, "left");
      this.addCenteredText(
        pdf,
        this.formBox.productQuantity.toString(),
        8.25 * cmToPoints,
        "left"
      );

      this.addCenteredText(pdf, "Presentación", 7.1 * cmToPoints, "right");
      this.addCenteredText(pdf, "PZA", 8.25 * cmToPoints, "right");

      pdf.setDrawColor(0, 0, 0);
      pdf.setLineWidth(1.5);

      const startX = 5 * cmToPoints;
      const startY = labelSize - 0.2 * cmToPoints - 3.2 * cmToPoints;
      const endY = labelSize - 0.2 * cmToPoints;

      pdf.line(startX, startY, startX, endY);

      const now = new Date();
      const date = now
        .toLocaleString("es-ES", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(/,/g, "");
      pdf.save(`etiqueta_kit_${date}.pdf`);
    },

    /**
     * Distributes products evenly across boxes
     * @param {Number} total - Total products to distribute
     * @param {Number} numberOfBoxes - Number of boxes to distribute into
     * @returns {Array} Array of product counts per box
     */
    distributeInBoxes(total, numberOfBoxes) {
      const result = [];
      const baseValue = Math.floor(total / numberOfBoxes);
      let remainder = total % numberOfBoxes;

      for (let i = 0; i < numberOfBoxes; i++) {
        if (i < remainder) {
          result.push(baseValue + 1);
        } else {
          result.push(baseValue);
        }
      }

      result.sort((a, b) => b - a);
      return result;
    },

    /**
     * Generates box labels PDF
     * @param {Number} boxesToGenerate - Number of boxes to generate labels for
     * @param {Number} startBox - Starting box number
     * @param {Number} endBox - Ending box number
     * @param {Array} boxDistribution - Product distribution across boxes
     */
    async generateBoxLabels(
      boxesToGenerate,
      startBox,
      endBox,
      boxDistribution
    ) {
      const cmToPoints = 28.3465;
      const labelSize = 10 * cmToPoints;
      const pdf = new jsPDF({
        unit: "pt",
        format: [labelSize, labelSize],
      });

      for (let index = 0; index < boxesToGenerate; index++) {
        const productQty = boxDistribution[index] || 0;

        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(15);
        pdf.setDrawColor(0, 0, 0);

        pdf.setLineWidth(1.5);
        pdf.rect(5, 5, labelSize - 10, labelSize - 10);

        pdf.setLineWidth(1.5);
        pdf.line(5, 3.3 * cmToPoints, labelSize - 5, 3.3 * cmToPoints);
        pdf.line(5, 6.6 * cmToPoints, labelSize - 5, 6.6 * cmToPoints);

        pdf.text("No. Caja", 0.5 * cmToPoints, 0.8 * cmToPoints);
        pdf.text(
          `${startBox + index}/${this.totalBoxes}`,
          0.5 * cmToPoints,
          1.3 * cmToPoints
        );

        this.addCenteredText(pdf, "Cliente", 1 * cmToPoints);
        this.addCenteredText(pdf, this.formBox.orderNumber, 1.5 * cmToPoints);
        this.addCenteredText(pdf, this.formBox.clientName, 2 * cmToPoints);
        if (this.formBox.nameLabelBox && this.formBox.nameLabelBox.length > 0) {
          this.addCenteredText(
            pdf,
            this.formBox.nameLabelBox,
            2.5 * cmToPoints
          );
        }

        let currentName = "";
        if (typeof this.formBox.microorganismName !== "object") {
          currentName = this.formBox.microorganismName;
        } else {
          currentName = this.formBox.microorganismName.identificationName;
        }
        pdf.text("Producto", 0.5 * cmToPoints, 3.8 * cmToPoints);
        this.addCenteredText(pdf, currentName, 4.95 * cmToPoints);

        this.addCenteredText(pdf, "Cantidad", 7.1 * cmToPoints, "left");
        this.addCenteredText(
          pdf,
          productQty.toString(),
          8.25 * cmToPoints,
          "left"
        );

        this.addCenteredText(pdf, "Presentación", 7.1 * cmToPoints, "right");
        this.addCenteredText(
          pdf,
          this.formBox.presentation.text,
          8.25 * cmToPoints,
          "right"
        );

        pdf.setDrawColor(0, 0, 0);
        pdf.setLineWidth(1.5);

        const startX = 5 * cmToPoints;
        const startY = labelSize - 0.2 * cmToPoints - 3.2 * cmToPoints;
        const endY = labelSize - 0.2 * cmToPoints;

        pdf.line(startX, startY, startX, endY);

        if (index < boxesToGenerate - 1) {
          pdf.addPage();
        }
      }

      const now = new Date();
      const date = now
        .toLocaleString("es-ES", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(/,/g, "");
      pdf.save(`etiquetas_caja_${date}_${startBox}-${endBox}`);
    },

    /**
     * Returns validation rules for form fields
     * @param {String} name - Field name
     * @returns {Array} Validation rules
     */
    validation(name) {
      return requiredValidation(name);
    },
  },

  watch: {
    /**
     * Watches search input for microorganism autocomplete
     * @param {String} val - Search term
     */
    async search(val) {
      if (!val) return;

      this.loader = true;

      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }

      this.SET_CANCEL_TOKEN(axios.CancelToken.source());

      try {
        const response = await this.searchBioactives({
          name: val,
        });
        if (response.error) throw response;

        this.identificationsFounded = response.strains;
        this.identificationsFounded.push({
          identificationName: "Ag Boost",
        });
      } catch (e) {
        console.error("Error searching bioactives:", e);
      }
      this.loader = false;
    },
  },
};
</script>